import { createClient } from 'contentful'
import type { InvoiceVirtualTour } from '../types/virtualTour.types'
import { mapTour, sortVirtualTours, type TourEntry } from './virtualTour.mappers'

const contentfulAccessToken = import.meta.env
  .VITE_APP_PUBLIC_CONTENTFUL_DELIVERY_TOKEN as string | undefined
const contentfulSpaceId = import.meta.env.VITE_APP_PUBLIC_CONTENTFUL_SPACE_ID as
  | string
  | undefined

export const hasInvoiceVirtualTourContentfulConfig = Boolean(
  contentfulAccessToken && contentfulSpaceId,
)

const contentfulClient = hasInvoiceVirtualTourContentfulConfig
  ? createClient({
      accessToken: contentfulAccessToken as string,
      space: contentfulSpaceId as string,
      environment:
        (import.meta.env.VITE_APP_PUBLIC_CONTENTFUL_ENVIRONMENT as string | undefined) ??
        (import.meta.env.PROD ? 'production' : 'staging'),
    })
  : null

export type TourContentPort = {
  getActiveTours: () => Promise<InvoiceVirtualTour[]>
}

export const defaultTourContentPort: TourContentPort = {
  getActiveTours: async () => {
    if (!contentfulClient) {
      return []
    }

    const collection = (await contentfulClient.getEntries({
      content_type: 'tour',
      include: 3,
    })) as unknown as { items?: TourEntry[] }

    return sortVirtualTours(
      (collection.items ?? []).map(mapTour).filter((tour) => tour != null),
    )
  },
}

export const getActiveInvoiceVirtualTours = (): Promise<InvoiceVirtualTour[]> =>
  defaultTourContentPort.getActiveTours()
